import PropTypes from 'prop-types';
import { get } from 'lodash';
import useDeepCompareEffect from 'hooks/useDeepCompareEffect';
import { track } from 'analytics/utilities';
import { EVENT_NAMES } from 'analytics/constants';
import errorParser from 'utilities/graphql/errorParser';
import { useData, usePaginatedData } from './helpers';

export const useDataQuery = (
  queryObject,
  variables = {},
  additionalOptions = {
    /*
      https://formidable.com/open-source/urql/docs/basics/queries/
      requestPolicy and pause
    */
  }
) => {
  if (!queryObject) {
    return {
      fetching: false,
      data: undefined,
      error: new Error('bad query'),
    };
  }
  const paginated = get(queryObject, 'paginated', false);
  const handleRequest = paginated ? usePaginatedData : useData;
  const result = handleRequest(queryObject, variables, additionalOptions);

  useDeepCompareEffect(() => {
    if (result.error) {
      track(EVENT_NAMES.ERROR, result);
    }
    if (!result.fetching && result.data) {
      track(EVENT_NAMES.QUERY, result);
    }
  }, [result]);

  return {
    ...result,
    error: errorParser(result.error),
  };
};


useDataQuery.propTypes = {
  // urql useQuery result shape https://formidable.com/open-source/urql/docs/api/urql/#usequery
  queryObject: PropTypes.shape({
    data: PropTypes.any.isRequired,
    fetching: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
  }).isRequired,
  variables: PropTypes.object,
  fields: PropTypes.array,
};
